<template>
  <div>
    <v-btn @click="onClickEdit" class="mb-3">
      <v-icon>mdi-pencil</v-icon>
      {{ $t("button.edit") }}
    </v-btn>
    <div class="text-caption">
      {{ $t("projects.general.nameLabel") }}
    </div>
    <div>
      {{ project.project_name }}
    </div>
    <div class="text-caption mt-3">
      {{ $t("projects.general.descriptionLabel") }}
    </div>
    <div class="description">
      {{ project.details }}
    </div>
    <div class="text-caption mt-3">
      {{ $t("projects.general.createdOn") }}
    </div>
    <div>
      {{ project.created | formatDate }}
    </div>
    <div class="text-caption mt-3">
      {{ $t("projects.general.lastUpdateOn") }}
    </div>
    <div>
      {{ project.last_updated | formatDate }}
    </div>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <ValidationObserver slim v-slot="{ invalid }">
        <v-card>
          <v-card-title>
            <span class="headline">
              {{ $t("projects.general.edit.title") }}
            </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <ValidationProvider slim v-slot="{ errors }" rules="required">
                  <v-text-field
                    v-model="project.project_name"
                    :label="$t('projects.general.edit.nameLabel')"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-row>
              <v-row>
                <ValidationProvider slim v-slot="{ errors }" rules="required">
                  <v-textarea
                    v-model="project.details"
                    :label="$t('projects.general.edit.descriptionLabel')"
                    :error-messages="errors"
                  ></v-textarea>
                </ValidationProvider>
              </v-row>
              <v-row>
                <v-text-field
                  disabled
                  :value="project.created | formatDate"
                  :label="$t('projects.general.edit.createdOn')"
                ></v-text-field>
              </v-row>
              <v-row>
                <v-text-field
                  disabled
                  :value="project.last_updated | formatDate"
                  :label="$t('projects.general.edit.lastUpdateOn')"
                ></v-text-field>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="dialog = false"
              :disabled="loading"
            >
              {{ $t("button.cancel") }}
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="onClickDialogSave"
              :disabled="invalid"
              :loading="loading"
            >
              {{ $t("button.save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { editProject } from "@/api/craiyon";

export default {
  props: {
    project: { required: true }
  },
  data: () => ({
    dialog: false,
    dialogButtonCancelDisabled: false,
    loading: false
  }),
  computed: {
    ...mapState({ token: state => state.authentication.keycloak.token }),
    notifyText() {
      return this.$t("projects.general.edit.actionCompleted");
    }
  },
  methods: {
    onClickEdit() {
      this.dialog = true;
    },
    async onClickDialogSave() {
      this.loading = true;
      await editProject(this.token, this.project);
      this.dialog = false;
      this.$notify({
        text: this.notifyText,
        type: "success"
      });
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.description {
  white-space: break-spaces;
}
</style>
